import React from 'react';
import { cn } from '@/lib/utils';

type SkeletonCardProps = {
  count?: number;
  className?: string;
};

export const SkeletonCard: React.FC<SkeletonCardProps> = ({ count = 4, className }) => {
  return (
    <div className={cn("grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-4", className)}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-lg border p-4">
          <div className="h-5 w-1/2 mb-3 animate-pulse rounded bg-muted" />
          <div className="h-8 w-2/3 animate-pulse rounded bg-muted" />
        </div>
      ))}
    </div>
  );
};


